<template>
  <div>
    <div class="modal" v-if="visible" style="width: 410px">
      <div class="headers">
        <span>审批详情</span>
      </div>
      <div class="body">
        <el-form ref="form" :model="nodeForm" label-width="70px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="节点名称" prop="name">
                <el-input class="form-control" id="name" v-model="nodeForm.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="节点编码" prop="code">
                <el-input class="form-control" id="code" v-model="nodeForm.code"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否领导" prop="approverType">
                <el-radio-group v-model="nodeForm.approverType" @change="radioChange">
                  <el-radio :label="0">固定审批人</el-radio>
                  <el-radio :label="1">部门领导</el-radio>
                  <el-radio :label="2">人员控件</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item v-if="nodeForm.approverType == 0" label="审批人" prop="selects">
                <el-select multiple v-model="selects" placeholder="请选择" @change="handleChangeApprover" filterable :filter-method="getApproverList">
                  <el-option v-for="item in approvers" :key="'approver-' + item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item v-if="nodeForm.approverType == 2" label="表单控件" prop="tableControlCode">
                <el-select v-model="nodeForm.tableControlCode" placeholder="请选择">
                  <el-option v-for="item in attrList" :key="item.key" :label="item.name" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- <label for="name">节点名称</label>
        <el-input
          class="form-control"
          id="name"
          v-model="nodeForm.name"
        ></el-input>
        <label for="type">节点编码</label>
        <el-input
          class="form-control"
          id="type"
          v-model="nodeForm.code"
        ></el-input>
        <label for="type">是否领导</label>
        <div class="radioGroup">
          <el-radio-group v-model="nodeForm.approverType" @change="radioChange">
            <el-radio :label="0">固定审批人</el-radio>
            <el-radio :label="1">部门领导</el-radio>
            <el-radio :label="2">人员控件</el-radio>
          </el-radio-group>
        </div>
        <label for="approver" v-if="nodeForm.approverType == 0">审批人</label>
        <el-select
          multiple
          v-if="nodeForm.approverType == 0"
          v-model="selects"
          placeholder="请选择"
          @change="handleChangeApprover"
          filterable
          :filter-method="getApproverList"
        >
          <el-option
            v-for="item in approvers"
            :key="'approver-' + item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <label for="approver" v-if="nodeForm.approverType == 2">表单控件</label>
        <el-select
          v-if="nodeForm.approverType == 2"
          v-model="nodeForm.tableControlCode"
          placeholder="请选择"
        >
          <el-option
            v-for="item in attrList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select> -->
      </div>
      <div class="footer">
        <el-button v-preventReClick
            @click="handleClickCancelSaveNode">取消</el-button>
        <el-button v-preventReClick
            @click="handleClickSaveNode" type="primary">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import '../assets/modal.css';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    node: {
      type: Object,
      default: null,
    },
    approvers: {
      type: Array,
      default () {
        return []
      }
    },
    attrList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      nodeForm: { name: null, id: null, code: null, approverType: 0, tableControlCode: null, type: null, approver: [] },
      // approvers: [{ id: 1, name: 'Joyce' }, { id: 2, name: 'Allen' }, { id: 3, name: 'Teresa' }],
      selects: []
    };
  },
  methods: {
    handleClickSaveNode () {
      this.$emit('update:node', Object.assign(this.node, {
        name: this.nodeForm.name,
        type: this.nodeForm.type,
        code: this.nodeForm.code,
        approverType: this.nodeForm.approverType,
        tableControlCode: this.nodeForm.tableControlCode,
        approvers: [...Object.assign([], this.nodeForm.approver)],
        approverIds: this.selects.join(';')
      }));
      this.$emit('update:visible', false);
    },
    handleClickCancelSaveNode () {
      this.$emit('update:visible', false);
    },
    radioChange (label) {
      // if (label == '1') {
      //   this.nodeForm.approver = []
      // }
    },
    handleChangeApprover (e) {
      // parseInt(e.target.value)
      // this.nodeForm.approver = []
      // let arr = this.approvers.filter(i => e.indexOf(i.id) != -1);
      // if (arr.length > 0) {
      //   for (let item of arr) {
      //     this.nodeForm.approver.push(item)
      //   }
      // }
      // console.log(this.nodeForm.approver)
      // this.selects = e
    },
    getApproverList (keyWord) {
      this.$emit('getApproverList', keyWord)
    }
  },
  watch: {
    node: {
      immediate: true,
      handler (val) {
        if (!val) { return; }
        console.log(val)
        this.nodeForm.id = val.id;
        this.nodeForm.name = val.name;
        this.nodeForm.type = val.type;
        this.nodeForm.code = val.code;
        this.nodeForm.approverType = val.approverType;
        this.nodeForm.tableControlCode = val.tableControlCode;
        if (val.approvers && val.approvers.length > 0) {
          this.nodeForm.approver = val.approvers[0] instanceof Array ? val.approvers[0] : val.approvers;
          if (val.approvers[0] instanceof Array) {
            this.selects = val.approvers[0].map(item => {
              return item.id
            });
          } else {
            this.selects = val.approvers.map(item => {
              return item.id
            });
          }
        }
      },
    },
  },
};
</script>

<style scope>
.modal {
  border: 1px solid #d3d3d3;
  /* box-shadow: 2px 2px 1px #d3d3d3; */
  background-color: white;
  top: 100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}

.form-control {
  display: block;
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
}
.radioGroup {
  margin: 10px 0;
}
.footer {
  padding: 10px;
  text-align: right;
}

.footer > button {
  margin-left: 10px;
}

.body {
  padding: 10px;
}

.headers {
  padding: 10px;
  border-bottom: 1px solid #d3d3d3;
}
</style>